import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@/application/i18n/language'
import { investigationSlug } from '@/application/seo/investigation-url'
import { ArticleMeta } from './ArticleMeta'
import type { HomeCategoryRail } from '../selectHomeSections'

/** Up to 4 rails: rule + section title + 3-4 items. */
export function HomeCategorySections({ rails }: { rails: HomeCategoryRail[] }) {
  const { t, i18n } = useTranslation()
  const locale = resolveLanguage(i18n.language)
  if (rails.length === 0) return null

  return (
    <div className="space-y-10">
      {rails.map((rail) => (
        <div key={rail.termId}>
          <h2 className="font-serif text-lg font-bold text-foreground border-b-2 border-border pb-2 mb-4">
            {t('home.category_section_title', { category: rail.label })}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {rail.items.map((investigation) => (
              <Link
                key={investigation.id}
                to="/investigations/$slug"
                params={{ slug: investigationSlug(investigation, locale) }}
                className="group block"
              >
                <div className="w-full aspect-video bg-muted overflow-hidden rounded-lg mb-2">
                  <img
                    src={investigation.imageUrl || '/logo.png'}
                    alt={investigation.name}
                    className={`w-full h-full transition-transform duration-300 group-hover:scale-105 ${
                      investigation.imageUrl ? 'object-cover' : 'object-contain p-6 opacity-40'
                    }`}
                  />
                </div>
                <h3 className="font-serif text-sm font-bold text-foreground group-hover:underline line-clamp-2">
                  {investigation.name}
                </h3>
                <ArticleMeta investigation={investigation} className="mt-1" />
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
